import { BaseService } from "services/base-service";

import { API_ROUTES } from "constants/routes";

class CentralEmailThreadsService extends BaseService {
  constructor(url, api) {
    super(url, api);
    this.getEmailThreads = this.getEmailThreads.bind(this);
    this.getEmailThread = this.getEmailThread.bind(this);
    this.patchEmailThread = this.patchEmailThread.bind(this);
  }

  async getEmailThreads(params) {
    try {
      const response = await this.agent.get("", params);

      return Promise.resolve(response);
    } catch (error) {
      this.processError(error);
      return null;
    }
  }

  async getEmailThread(id) {
    try {
      const response = await this.agent.get(`/${id}`, {
        params: {
          // The nested include is spelled out next to its parent: asking for
          // the attachments alone leaves responses without the emails that
          // own them.
          include:
            "central_email_messages,central_email_messages.central_email_attachments",
        },
      });

      return Promise.resolve(response);
    } catch (error) {
      this.processError(error);
      return null;
    }
  }

  async patchEmailThread(id, data) {
    try {
      const response = await this.agent.patch(`/${id}`, data);

      return Promise.resolve(response);
    } catch (error) {
      this.processError(error);
      return null;
    }
  }
}

const ServiceInstance = new CentralEmailThreadsService(
  API_ROUTES.centralEmailThreads
);

export default ServiceInstance;
export { ServiceInstance as CentralEmailThreadsService };
